import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonClientService } from '../common-client-service.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceNowClientService {
  constructor(private readonly _commonClientService: CommonClientService) {}

  /**
   * @public Opens a popup of ServiceNow login page, on successful authentication returns auth code that later will be redeemed for access token
   * @returns an Observable{string} with the the auth code
   */
  public popUpServiceNowToRetrieveAuthCode(
    serviceNowInstanceURL: string,
    serviceNowClientId: string
  ): Observable<string> {
    // Random generated string that is attached to the request and should be asserted to be attached also in response
    const state = uuidv4();

    const serviceNowLoginUrl = new URL(serviceNowInstanceURL + '/oauth_auth.do');

    serviceNowLoginUrl.searchParams.append('client_id', serviceNowClientId);
    serviceNowLoginUrl.searchParams.append('redirect_uri', environment.zenityRedirectUriForOauthAuthorizationCodeFlow);
    serviceNowLoginUrl.searchParams.append('state', state);
    serviceNowLoginUrl.searchParams.append('response_type', 'code');

    return this._commonClientService.openPopupToRetrieveAuthCode('ServiceNow', serviceNowLoginUrl, state);
  }
}
